import { App } from "../interfaces"

export function hasAccessPolicy(
  policy: App.AccessPolicy,
  auth: App.AuthState | null | undefined,
): boolean {
  if (
    ![
      App.AccessPolicy.BOT_MONITOR_READ,
      App.AccessPolicy.USERBOT_TRACKING_READ,
      App.AccessPolicy.USERBOT_TRACKING_WRITE,
      App.AccessPolicy.POST_BOT_READ,
      App.AccessPolicy.POST_BOT_WRITE,
    ].includes(policy) ||
    !auth?.token?.trim()
  ) {
    return false
  }

  if (auth.type === App.AuthType.STANDARD) {
    return (
      auth.role === App.UserRole.ADMIN || auth.role === App.UserRole.MANAGER
    )
  }

  if (auth.type === App.AuthType.OIDC) {
    const roles = (auth.userInfo as App.OIDCUserInfo | undefined)?.roles
    // Only PostBot's canonical policy is case-insensitive. Do not rewrite raw
    // claims or silently broaden existing module / tracking policies.
    if (
      policy === App.AccessPolicy.POST_BOT_READ ||
      policy === App.AccessPolicy.POST_BOT_WRITE
    ) {
      const required =
        policy === App.AccessPolicy.POST_BOT_READ ? "post_bot:r" : "post_bot:w"
      return (
        roles?.some((role) =>
          ["admin", "operator", required].includes(role.toLowerCase()),
        ) ?? false
      )
    }
    return (
      roles?.some((role) =>
        [
          "admin",
          "operator",
          policy === App.AccessPolicy.USERBOT_TRACKING_WRITE
            ? "userbot:w"
            : "userbot:r",
        ].includes(role),
      ) ?? false
    )
  }

  return false
}
